export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '제목'}, {name: '발행일'}, {name: '최종처리 이행확인'}, {name: '재해형태'}, {name: '작성자'}, {name: '작성일'}, {name: '첨부파일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputB_5
      case 2: return func.getContent(value).inputB_2
      case 3: return func.getContent(value).inputE_1
      case 4: return func.getContent(value).inputE_2
      case 5: return func.getContent(value).stdInfo.writer_name
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      case 7: return { type: 'file', files: func.getContent(value).fileList}
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputB_2) {
      nav.dateTarget = 'content$body.inputB_2'
      nav.dateBegin = 'nav.value.inputB_2.sDate'
      nav.dateEnd = 'nav.value.inputB_2.eDate'
    }
    return {inputB_2: nav.value.inputB_2, inputE_2: nav.value.inputE_2, inputE_1: nav.value.inputE_1}
  },
  getSearchKeyword: (nav) => {
    return [
      'content$body.inputE_2*[:nav.page.p76.inputE_2]',
      'content$body.inputE_1*[:nav.page.p76.inputE_1]'
    ]
  },
}
